"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBookingsConfig = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const jfd_smt_type10_1 = require("../common-defs/jfd-smt-type10");
const jfl_smt_type10_1 = require("../common-defs/jfl-smt-type10");
const genericCaptureAnnotations_1 = require("./genericCaptureAnnotations");
const defaultConfig = {
    edit: false,
    printTypes: [],
    userFilteredPrintTypes: function (user) {
        return this.printTypes;
    },
    onlyMandatoryCheckbox: true,
    activeCaptureAnnotationCode: genericCaptureAnnotations_1.genericActiveAnnotationCode,
    smt: {
        strategy: 'type10',
        jfd: jfd_smt_type10_1.jfdSmt,
        jfl: jfl_smt_type10_1.jflSmt
    },
    fingerprint: {
        preCaptureAnnotations: genericCaptureAnnotations_1.genericFingerprintPreCaptureAnnotations,
        postCaptureAnnotations: []
    },
    palm: {
        preCaptureAnnotations: genericCaptureAnnotations_1.genericPalmprintPreCaptureAnnotations,
        postCaptureAnnotations: []
    },
    iris: {
        preCaptureAnnotations: genericCaptureAnnotations_1.genericIrisPreCaptureAnnotations,
        postCaptureAnnotations: []
    },
    table: {
        columns: [],
        sort: [],
        multipleSelection: false
    },
    search: {
        simple: [],
        advanced: []
    },
    printFields: [],
    import: {
        whitelist: [],
        redlist: []
    }
};
function createBookingsConfig(config) {
    var _a, _b;
    // merge the default config with the provided values
    const result = merge_1.default({}, defaultConfig, config);
    // these need to be manually set since we want the provided JFD/JFL instances,
    // not merge the default one
    result.smt.jfd = ((_a = config.smt) === null || _a === void 0 ? void 0 : _a.jfd) || jfd_smt_type10_1.jfdSmt;
    result.smt.jfl = ((_b = config.smt) === null || _b === void 0 ? void 0 : _b.jfl) || jfl_smt_type10_1.jflSmt;
    return result;
}
exports.createBookingsConfig = createBookingsConfig;
//# sourceMappingURL=bookings-partial.js.map